import React from 'react'
import {Link} from 'react-router-dom'
export default function footer() {


    function mouseover(e) {
        e.target.style.color = "green"
    }

    function mouseout(e) {
        e.target.style.color = "white"
    }

    return (
        <>

            <div className='' style={{ backgroundColor: "black", paddingTop:"10%", textAlign:"center", height: "300px", display: "block" }} >

                <div className="social-icons" >

                    <Link to= "https://www.linkedin.com/in/kankopb/" target='_blank' style={{ textDecoration: "none" }}>
                        <i onMouseOver={mouseover} onMouseOut={mouseout} style={{ color: "white" }} className="fab fa-linkedin fa-xl mx-2"></i>
                    </Link>

                    <Link to= "https://twitter.com/kankopb/" target='_blank' style={{ textDecoration: "none" }}>
                        <i onMouseOver={mouseover} onMouseOut={mouseout} style={{ color: "white" }} className="fab fa-twitter fa-xl mx-2"></i>
                    </Link>

                    <Link to= "https://www.instagram.com/kankopb/" target='_blank' className="social-icon" style={{ textDecoration: "none" }}>
                        <i onMouseOver={mouseover} onMouseOut={mouseout} className="fab fa-instagram fa-xl mx-2"></i>


                    </Link>

                
                </div>
            </div>

        </>
    )
}